import {schemaMigrations, createTable, addColumns} from '@nozbe/watermelondb/Schema/migrations';

export default schemaMigrations({
    migrations: [],
});
